import HeaderSearchInputIcon from "@gaiaherbs/Icons/HeaderSearchInputIcon";
import { searchInputStyles } from "@insite/content-library/Widgets/Header/HeaderSearchInput";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

searchInputStyles.searchInputStyles = {
    input: {
        iconProps: {
            src: HeaderSearchInputIcon,
            size: 60,
        },
        css: css`
            background: #f3f3f3 !important;
            border: 2px solid #d1412440 !important;
            border-radius: 10px !important;
        `,
        cssOverrides: {
            formInputWrapper: css`
                button[class^="StyledButton-sc"] {
                    width: 90px;
                }
                button[class^="StyledButton-sc"] span[class^="IconWrapper-sc"] {
                    background: ${getColor("common.accent")};
                    border-radius: 0px 8px 8px 0px;
                    width: 100%;
                    padding: 0px;
                    svg {
                        width: 90px !important;
                        height: 24px !important;
                    }
                }
            `,
        },
    },
    popoverContentBody: {
        css: css`
            width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        left: 0;
                    `,
                    css`
                        width: 100%;
                        left: 0;
                    `,
                    css`
                        position: absolute !important;
                        top: 40px !important;
                        right: 0 !important;
                    `,
                    css`
                        position: absolute !important;
                        top: 40px !important;
                        right: 0 !important;
                    `,
                    css`
                        position: absolute !important;
                        top: 40px !important;
                        right: 0 !important;
                    `,
                ])}
        `,
    },
};
